import { type SelectOption } from "@revmatics/catalyst";

export const roleOptions: SelectOption[] = [
  { label: "Organization Admin", value: "ORGANIZATION_ADMIN" },
  { label: "Organization Member", value: "ORGANIZATION_MEMBER" },
];
